import React from "react"
import { Button } from "../util"

const ShareButton = ({ data, onClick, isListButton, color }) =>
  (
    <Button
      isListButton={isListButton}
      color={color}
      onClick={() => {

      }}
    >
      <div className="title">Share</div>
    </Button>
  )

export default ShareButton
